import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { IFrameWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-iframe.sass');

export class IFrameWidget extends WidgetBase {
    public static _name: string = 'IFrame';
    public static moduleName: string = 'pdc-widget-iframe';
    public static namespace: string = 'business-intelligence';
    public static icon: string = 'globe';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-iframe'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(IFrameWidget);
